// Category styling configuration with distinct emojis
export const categoryStyles = {
  electronics: { bg: "bg-blue-500", emoji: "🔌", color: "from-blue-400 to-blue-600" },
  phones: { bg: "bg-teal-500", emoji: "📱", color: "from-teal-400 to-teal-600" },
  computers: { bg: "bg-sky-500", emoji: "🖥️", color: "from-sky-400 to-sky-600" },
  fashion: { bg: "bg-pink-500", emoji: "👗", color: "from-pink-400 to-pink-600" },
  shoes: { bg: "bg-orange-500", emoji: "👟", color: "from-orange-400 to-orange-600" },
  watches: { bg: "bg-yellow-500", emoji: "⌚", color: "from-yellow-400 to-yellow-600" },
  bags: { bg: "bg-amber-500", emoji: "👜", color: "from-amber-400 to-amber-600" },
  collectibles: { bg: "bg-purple-500", emoji: "🏆", color: "from-purple-400 to-purple-600" },
  antiques: { bg: "bg-stone-500", emoji: "🏺", color: "from-stone-400 to-stone-600" },
  coins: { bg: "bg-yellow-600", emoji: "🪙", color: "from-yellow-500 to-yellow-700" },
  art: { bg: "bg-indigo-500", emoji: "🎨", color: "from-indigo-400 to-indigo-600" },
  music: { bg: "bg-violet-500", emoji: "🎵", color: "from-violet-400 to-violet-600" },
  books: { bg: "bg-amber-600", emoji: "📚", color: "from-amber-500 to-amber-700" },
  sports: { bg: "bg-green-500", emoji: "⚽", color: "from-green-400 to-green-600" },
  outdoor: { bg: "bg-lime-500", emoji: "🏕️", color: "from-lime-400 to-lime-600" },
  fitness: { bg: "bg-red-500", emoji: "💪", color: "from-red-400 to-red-600" },
  home: { bg: "bg-cyan-500", emoji: "🏠", color: "from-cyan-400 to-cyan-600" },
  garden: { bg: "bg-green-600", emoji: "🌱", color: "from-green-500 to-green-700" },
  tools: { bg: "bg-slate-500", emoji: "🔧", color: "from-slate-400 to-slate-600" },
  toys: { bg: "bg-pink-400", emoji: "🧸", color: "from-pink-300 to-pink-500" },
  games: { bg: "bg-fuchsia-500", emoji: "🎮", color: "from-fuchsia-400 to-fuchsia-600" },
  baby: { bg: "bg-rose-400", emoji: "👶", color: "from-rose-300 to-rose-500" },
  pets: { bg: "bg-amber-400", emoji: "🐾", color: "from-amber-300 to-amber-500" },
  health: { bg: "bg-emerald-500", emoji: "💊", color: "from-emerald-400 to-emerald-600" },
  beauty: { bg: "bg-pink-500", emoji: "💄", color: "from-pink-400 to-pink-600" },
  vehicles: { bg: "bg-red-600", emoji: "🚗", color: "from-red-500 to-red-700" },
  motorcycles: { bg: "bg-gray-600", emoji: "🏍️", color: "from-gray-500 to-gray-700" },
  parts: { bg: "bg-zinc-500", emoji: "⚙️", color: "from-zinc-400 to-zinc-600" },
  business: { bg: "bg-blue-600", emoji: "💼", color: "from-blue-500 to-blue-700" },
  industrial: { bg: "bg-gray-500", emoji: "🏭", color: "from-gray-400 to-gray-600" },
  jewelry: { bg: "bg-yellow-500", emoji: "💎", color: "from-yellow-400 to-yellow-600" },
  crafts: { bg: "bg-rose-500", emoji: "✂️", color: "from-rose-400 to-rose-600" },
  cameras: { bg: "bg-slate-600", emoji: "📷", color: "from-slate-500 to-slate-700" },
  gaming: { bg: "bg-fuchsia-500", emoji: "🎮", color: "from-fuchsia-400 to-fuchsia-600" },
  "pet-supplies": { bg: "bg-amber-500", emoji: "🐾", color: "from-amber-400 to-amber-600" },
  tickets: { bg: "bg-indigo-400", emoji: "🎫", color: "from-indigo-300 to-indigo-500" },
  food: { bg: "bg-orange-400", emoji: "🍕", color: "from-orange-300 to-orange-500" },
  wine: { bg: "bg-red-400", emoji: "🍷", color: "from-red-300 to-red-500" },
  other: { bg: "bg-gray-400", emoji: "📦", color: "from-gray-300 to-gray-500" },
};
